import { get_COROUTINE_SUSPENDED3ujt3p13qm4iy as get_COROUTINE_SUSPENDED } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/Intrinsics.mjs';
import { Unit_instance1fbcbse1fwigr as Unit_instance } from '../../../../../kotlin-kotlin-stdlib/kotlin/Unit.mjs';
import { suspendOrReturn49pspzlx5djv as suspendOrReturn } from '../../../../../kotlin-kotlin-stdlib/kotlin/coroutines/intrinsics/IntrinsicsJs.mjs';
import { VOID3gxj6tk5isa35 as VOID } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/void.mjs';
import {
  Frame1e7t2kcdb3wu7 as Frame,
  RowOrCol3a33s3yce2tuv as RowOrCol,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/ContainingView.commonHtml.mjs';
import { get_AppDimensions1ckwvsuun6046 as get_AppDimensions } from '../components/nav/AppDimensions.mjs';
import {
  Companion_getInstance1350ksylxva5s as Companion_getInstance,
  plus354lvypr4cqa1 as plus,
  ThemeDerivation3kcl449hwgd5y as ThemeDerivation,
  DialogSemantic_getInstance3cqn6ufjbbrs2 as DialogSemantic_getInstance,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/models/Theme.mjs';
import { timesx4ey3un7ihw1 as times } from '../../../../../kiteui-library/com/lightningkite/kiteui/models/data.mjs';
import {
  title1nssp3ryhwuqj as title,
  body3i5t0n7zprpqb as body,
} from '../theming/Titles.mjs';
import { isBlank1dvkhjjvox3p0 as isBlank } from '../../../../../kotlin-kotlin-stdlib/kotlin/text/Strings.mjs';
import { get_rem2p56fiaxda5jo as get_rem } from '../../../../../kiteui-library/com/lightningkite/kiteui/models/data.commonHtml.mjs';
import { sizeConstraints2hv7x4j4qpd36 as sizeConstraints } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/modifiers.mjs';
import { Button263cw152yl80e as Button } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.commonHtml.mjs';
import {
  specCenteredText1zemopd0g3rsf as specCenteredText,
  get_textButtonybbt8y3eu5hx as get_textButton,
  PrimaryButtonSemantic_getInstance2oopjxbt9oc9b as PrimaryButtonSemantic_getInstance,
} from '../theming/buttons.mjs';
import { onClick25t27tv78ic5x as onClick } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/Button.mjs';
import { get_dialogStackleaqvayyucjw as get_dialogStack } from '../components/nav/crowpay.mjs';
import {
  initMetadataForLambda3af3he42mmnh as initMetadataForLambda,
  initMetadataForClassbxx6q50dy2s7 as initMetadataForClass,
} from '../../../../../kotlin-kotlin-stdlib/kotlin/js/metadataUtils.mjs';
import { get_appThemejy2o9bdilpry as get_appTheme } from '../theming/appTheme.mjs';
import { protoOf180f3jzyo7rfj as protoOf } from '../../../../../kotlin-kotlin-stdlib/kotlin/js/coreRuntime.mjs';
import { DismissBackground1nezyx9ss0e1b as DismissBackground } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/direct/DismissBackground.commonHtml.mjs';
import { get_centered1xfu6or5nc0lq as get_centered } from '../../../../../kiteui-library/com/lightningkite/kiteui/views/helpers.mjs';
import {
  AdjacentCardsSemantic_getInstance26qn2so7ofz0z as AdjacentCardsSemantic_getInstance,
  signOffHeader11hami6texki7 as signOffHeader,
} from '../components/signOffHeader.mjs';
import {
  get_titlelss9nf4gv6ut as get_title,
  Page1o437w9xuocrm as Page,
} from '../../../../../kiteui-library/com/lightningkite/kiteui/navigation/Page.mjs';
import { THROW_CCE2g6jy02ryeudk as THROW_CCE } from '../../../../../kotlin-kotlin-stdlib/kotlin/hacks.mjs';
//region block: imports
//endregion
//region block: pre-declaration
//endregion
function *_generator_invoke__zhh2q8($this, $completion) {
  if ($this.nic_1.iic_1) {
    var tmp = $this.nic_1.mic_1(false, $completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
  }
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_0($this, $completion) {
  var tmp = render$submit($this.oic_1, $this.pic_1, true, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_invoke__zhh2q8_1($this, $completion) {
  var tmp = render$submit($this.qic_1, $this.ric_1, false, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  return Unit_instance;
}
function *_generator_render$submit__yn546q(this$0, $this_render, value, $completion) {
  var tmp = this$0.mic_1(value, $completion);
  if (tmp === get_COROUTINE_SUSPENDED())
    tmp = yield tmp;
  if (!value || this$0.jic_1)
    this$0.kic_1($this_render);
  return Unit_instance;
}
function render$submit(this$0, $this_render, value, $completion) {
  return suspendOrReturn(/*#__NOINLINE__*/_generator_render$submit__yn546q.bind(VOID, this$0, $this_render, value), $completion);
}
function render$_anonymous_$modal_lrn6vs(_this__u8e3s4, this$0, $this_render, this$0_0) {
  // Inline function 'com.lightningkite.kiteui.views.direct.frame' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view = new (Frame())(_this__u8e3s4.pc());
  var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
  var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
  _this__u8e3s4.ebb(p, view);
  view.eba(get_AppDimensions().wg1_1);
  view.zb8(get_AppDimensions().wg1_1);
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_0 = new (RowOrCol())(view.pc());
  var tmp0_elvis_lhs_0 = view.cbb_1;
  var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
  view.ebb(p_0, view_0);
  view_0.xbm(true);
  // Inline function 'com.lightningkite.kiteui.models.Companion.invoke' call
  Companion_getInstance();
  var tmp$ret$0 = new (GenericConfirmationDialog$render$_anonymous_$modal$$inlined$frame$1())();
  view_0.jba(tmp$ret$0);
  view_0.zb8(times(view_0.kba().hb0_1, 1.5));
  if (!(this$0_0.cic_1 == null)) {
    title(view_0, this$0_0.cic_1);
  }
  // Inline function 'com.lightningkite.kiteui.views.direct.col' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_1 = new (RowOrCol())(view_0.pc());
  var tmp0_elvis_lhs_1 = view_0.cbb_1;
  var p_1 = tmp0_elvis_lhs_1 == null ? view_0 : tmp0_elvis_lhs_1;
  view_0.ebb(p_1, view_1);
  view_1.xbm(true);
  // Inline function 'kotlin.text.isNotBlank' call
  var this_0 = this$0_0.dic_1;
  if (!isBlank(this_0)) {
    var tmp0_maxWidth = get_rem(40);
    var tmp1_minWidth = get_rem(10);
    view_1.jbb(sizeConstraints(view_1, tmp1_minWidth, tmp0_maxWidth), body(view_1, this$0_0.dic_1));
  }
  if (!(this$0_0.eic_1 == null)) {
    var tmp2_maxWidth = get_rem(40);
    var tmp3_minWidth = get_rem(10);
    view_1.jbb(sizeConstraints(view_1, tmp3_minWidth, tmp2_maxWidth), body(view_1, this$0_0.eic_1));
  }
  view_0.fbb(p_1, view_1);
  // Inline function 'com.lightningkite.kiteui.views.direct.row' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_2 = new (RowOrCol())(view_0.pc());
  var tmp0_elvis_lhs_2 = view_0.cbb_1;
  var p_2 = tmp0_elvis_lhs_2 == null ? view_0 : tmp0_elvis_lhs_2;
  view_0.ebb(p_2, view_2);
  view_2.xbm(false);
  view_2.zb8(get_AppDimensions().ig2_1);
  var tmp = view_2.hbb(this$0_0.hic_1);
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_3 = new (Button())(view_2.pc());
  var tmp0_elvis_lhs_3 = view_2.cbb_1;
  var p_3 = tmp0_elvis_lhs_3 == null ? view_2 : tmp0_elvis_lhs_3;
  view_2.ebb(p_3, view_3);
  specCenteredText(view_3, this$0_0.fic_1);
  onClick(view_3, VOID, VOID, GenericConfirmationDialog$render$_anonymous_$modal$slambda_iywbxq_0(this$0, $this_render));
  view_2.fbb(p_3, view_3);
  view_2.jbb(tmp, view_3);
  var tmp_0 = get_textButton(view_2);
  // Inline function 'com.lightningkite.kiteui.views.direct.button' call
  // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
  var view_4 = new (Button())(view_2.pc());
  var tmp0_elvis_lhs_4 = view_2.cbb_1;
  var p_4 = tmp0_elvis_lhs_4 == null ? view_2 : tmp0_elvis_lhs_4;
  view_2.ebb(p_4, view_4);
  specCenteredText(view_4, this$0_0.gic_1);
  onClick(view_4, VOID, VOID, GenericConfirmationDialog$render$_anonymous_$modal$slambda_iywbxq_2(this$0, $this_render));
  view_2.fbb(p_4, view_4);
  view_2.jbb(tmp_0, view_4);
  view_0.fbb(p_2, view_2);
  view.fbb(p_0, view_0);
  _this__u8e3s4.fbb(p, view);
  return view;
}
function GenericConfirmationDialog$_init_$lambda_as24c7(_this__u8e3s4) {
  get_dialogStack().ngd();
  return Unit_instance;
}
var GenericConfirmationDialog$render$slambdaClass;
function GenericConfirmationDialog$render$slambda() {
  if (GenericConfirmationDialog$render$slambdaClass === VOID) {
    class $ {
      sao($completion) {
        get_dialogStack().ngd();
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    GenericConfirmationDialog$render$slambdaClass = $;
  }
  return GenericConfirmationDialog$render$slambdaClass;
}
function GenericConfirmationDialog$render$slambda_0() {
  var i = new (GenericConfirmationDialog$render$slambda())();
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
var GenericConfirmationDialog$render$slambdaClass_0;
function GenericConfirmationDialog$render$slambda_1() {
  if (GenericConfirmationDialog$render$slambdaClass_0 === VOID) {
    class $ {
      constructor(this$0) {
        this.nic_1 = this$0;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    GenericConfirmationDialog$render$slambdaClass_0 = $;
  }
  return GenericConfirmationDialog$render$slambdaClass_0;
}
function GenericConfirmationDialog$render$slambda_2(this$0) {
  var i = new (GenericConfirmationDialog$render$slambda_1())(this$0);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
var GenericConfirmationDialog$render$_anonymous_$modal$$inlined$frame$1Class;
function GenericConfirmationDialog$render$_anonymous_$modal$$inlined$frame$1() {
  if (GenericConfirmationDialog$render$_anonymous_$modal$$inlined$frame$1Class === VOID) {
    class $ {
      fd1(theme) {
        return get_appTheme().ab1_1;
      }
    }
    protoOf($).ybe = plus;
    initMetadataForClass($, VOID, VOID, VOID, [ThemeDerivation()]);
    GenericConfirmationDialog$render$_anonymous_$modal$$inlined$frame$1Class = $;
  }
  return GenericConfirmationDialog$render$_anonymous_$modal$$inlined$frame$1Class;
}
var GenericConfirmationDialog$render$_anonymous_$modal$slambda_iywbxqClass;
function GenericConfirmationDialog$render$_anonymous_$modal$slambda_iywbxq() {
  if (GenericConfirmationDialog$render$_anonymous_$modal$slambda_iywbxqClass === VOID) {
    class $ {
      constructor(this$0, $this_render) {
        this.oic_1 = this$0;
        this.pic_1 = $this_render;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_0.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    GenericConfirmationDialog$render$_anonymous_$modal$slambda_iywbxqClass = $;
  }
  return GenericConfirmationDialog$render$_anonymous_$modal$slambda_iywbxqClass;
}
function GenericConfirmationDialog$render$_anonymous_$modal$slambda_iywbxq_0(this$0, $this_render) {
  var i = new (GenericConfirmationDialog$render$_anonymous_$modal$slambda_iywbxq())(this$0, $this_render);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
var GenericConfirmationDialog$render$_anonymous_$modal$slambda_iywbxqClass_0;
function GenericConfirmationDialog$render$_anonymous_$modal$slambda_iywbxq_1() {
  if (GenericConfirmationDialog$render$_anonymous_$modal$slambda_iywbxqClass_0 === VOID) {
    class $ {
      constructor(this$0, $this_render) {
        this.qic_1 = this$0;
        this.ric_1 = $this_render;
      }
      sao($completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_1.bind(VOID, this), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    GenericConfirmationDialog$render$_anonymous_$modal$slambda_iywbxqClass_0 = $;
  }
  return GenericConfirmationDialog$render$_anonymous_$modal$slambda_iywbxqClass_0;
}
function GenericConfirmationDialog$render$_anonymous_$modal$slambda_iywbxq_2(this$0, $this_render) {
  var i = new (GenericConfirmationDialog$render$_anonymous_$modal$slambda_iywbxq_1())(this$0, $this_render);
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
var GenericConfirmationDialogClass;
function GenericConfirmationDialog() {
  if (GenericConfirmationDialogClass === VOID) {
    class $ {
      constructor(header, message, question, confirmationText, declineText, confirmationTheme, allowDismiss, dismissOnConfirm, dismiss, greyHeader, onSubmit) {
        question = question === VOID ? null : question;
        declineText = declineText === VOID ? 'Go Back' : declineText;
        confirmationTheme = confirmationTheme === VOID ? PrimaryButtonSemantic_getInstance() : confirmationTheme;
        allowDismiss = allowDismiss === VOID ? true : allowDismiss;
        dismissOnConfirm = dismissOnConfirm === VOID ? true : dismissOnConfirm;
        var tmp;
        if (dismiss === VOID) {
          tmp = GenericConfirmationDialog$_init_$lambda_as24c7;
        } else {
          tmp = dismiss;
        }
        dismiss = tmp;
        greyHeader = greyHeader === VOID ? null : greyHeader;
        this.cic_1 = header;
        this.dic_1 = message;
        this.eic_1 = question;
        this.fic_1 = confirmationText;
        this.gic_1 = declineText;
        this.hic_1 = confirmationTheme;
        this.iic_1 = allowDismiss;
        this.jic_1 = dismissOnConfirm;
        this.kic_1 = dismiss;
        this.lic_1 = greyHeader;
        this.mic_1 = onSubmit;
      }
      ud6(_this__u8e3s4) {
        // Inline function 'com.crowpay.views.components.dismissBackground2' call
        // Inline function 'com.lightningkite.kiteui.views.direct.dismissBackground' call
        // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
        var view = new (DismissBackground())(_this__u8e3s4.pc());
        var tmp0_elvis_lhs = _this__u8e3s4.cbb_1;
        var p = tmp0_elvis_lhs == null ? _this__u8e3s4 : tmp0_elvis_lhs;
        _this__u8e3s4.ebb(p, view);
        view.tbo(GenericConfirmationDialog$render$slambda_0());
        view.eba(get_AppDimensions().wg1_1);
        view.zb8(get_AppDimensions().wg1_1);
        if (this.lic_1 == null)
          view.jbb(view.ibb(get_centered(view), view.hbb(DialogSemantic_getInstance())), render$_anonymous_$modal_lrn6vs(view, this, _this__u8e3s4, this));
        else {
          var tmp = view.ibb(view.ibb(get_centered(view), view.hbb(AdjacentCardsSemantic_getInstance())), sizeConstraints(view, get_rem(25)));
          // Inline function 'com.lightningkite.kiteui.views.direct.col' call
          // Inline function 'com.lightningkite.kiteui.views.ViewWriter.write' call
          var view_0 = new (RowOrCol())(view.pc());
          var tmp0_elvis_lhs_0 = view.cbb_1;
          var p_0 = tmp0_elvis_lhs_0 == null ? view : tmp0_elvis_lhs_0;
          view.ebb(p_0, view_0);
          view_0.xbm(true);
          signOffHeader(view_0, this.lic_1, 'Decisions in this section may release escrow funds.', null);
          view_0.jbb(view_0.hbb(DialogSemantic_getInstance()), render$_anonymous_$modal_lrn6vs(view_0, this, _this__u8e3s4, this));
          view.fbb(p_0, view_0);
          view.jbb(tmp, view_0);
        }
        view.tbo(GenericConfirmationDialog$render$slambda_2(this));
        _this__u8e3s4.fbb(p, view);
        return view;
      }
    }
    protoOf($).ucv = get_title;
    initMetadataForClass($, 'GenericConfirmationDialog', VOID, VOID, [Page()], [3]);
    GenericConfirmationDialogClass = $;
  }
  return GenericConfirmationDialogClass;
}
function confirmationDialog(_this__u8e3s4, header, message, confirmationText, declineText, confirmationTheme, allowDismiss, dismissOnConfirm, greyHeader, onCancel, onConfirm) {
  declineText = declineText === VOID ? 'Go Back' : declineText;
  confirmationTheme = confirmationTheme === VOID ? PrimaryButtonSemantic_getInstance() : confirmationTheme;
  allowDismiss = allowDismiss === VOID ? true : allowDismiss;
  dismissOnConfirm = dismissOnConfirm === VOID ? true : dismissOnConfirm;
  greyHeader = greyHeader === VOID ? null : greyHeader;
  var tmp;
  if (onCancel === VOID) {
    tmp = confirmationDialog$slambda_0();
  } else {
    tmp = onCancel;
  }
  onCancel = tmp;
  var tmp_0 = get_dialogStack();
  tmp_0.xgd(new (GenericConfirmationDialog())(header, message, VOID, confirmationText, declineText, confirmationTheme, allowDismiss, dismissOnConfirm, VOID, greyHeader, confirmationDialog$slambda_2(onConfirm, onCancel)));
}
var confirmationDialog$slambdaClass;
function confirmationDialog$slambda() {
  if (confirmationDialog$slambdaClass === VOID) {
    class $ {
      sao($completion) {
        return Unit_instance;
      }
    }
    initMetadataForLambda($, VOID, VOID, [0]);
    confirmationDialog$slambdaClass = $;
  }
  return confirmationDialog$slambdaClass;
}
function confirmationDialog$slambda_0() {
  var i = new (confirmationDialog$slambda())();
  var l = ($completion) => i.sao($completion);
  l.$arity = 0;
  return l;
}
function *_generator_invoke__zhh2q8_2($this, it, $completion) {
  if (it) {
    var tmp = $this.sic_1($completion);
    if (tmp === get_COROUTINE_SUSPENDED())
      tmp = yield tmp;
  } else {
    var tmp_0 = $this.tic_1($completion);
    if (tmp_0 === get_COROUTINE_SUSPENDED())
      tmp_0 = yield tmp_0;
  }
  return Unit_instance;
}
var confirmationDialog$slambdaClass_0;
function confirmationDialog$slambda_1() {
  if (confirmationDialog$slambdaClass_0 === VOID) {
    class $ {
      constructor($onConfirm, $onCancel) {
        this.sic_1 = $onConfirm;
        this.tic_1 = $onCancel;
      }
      cgk(it, $completion) {
        return suspendOrReturn(/*#__NOINLINE__*/_generator_invoke__zhh2q8_2.bind(VOID, this, it), $completion);
      }
      s2(p1, $completion) {
        return this.cgk((!(p1 == null) ? typeof p1 === 'boolean' : false) ? p1 : THROW_CCE(), $completion);
      }
    }
    initMetadataForLambda($, VOID, VOID, [1]);
    confirmationDialog$slambdaClass_0 = $;
  }
  return confirmationDialog$slambdaClass_0;
}
function confirmationDialog$slambda_2($onConfirm, $onCancel) {
  var i = new (confirmationDialog$slambda_1())($onConfirm, $onCancel);
  var l = (it, $completion) => i.cgk(it, $completion);
  l.$arity = 1;
  return l;
}
//region block: exports
export {
  GenericConfirmationDialog as GenericConfirmationDialog172k63mmx5r2d,
  confirmationDialog as confirmationDialog1lynowl7yd4cd,
};
//endregion

//# sourceMappingURL=GenericConfirmationDialog.mjs.map
